import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, ArrowRight, ShieldCheck } from 'lucide-react';

export default function Login() {
  return (
    <div
      className="flex min-h-screen flex-col bg-gradient-to-bl from-primary/5 via-background to-secondary/5"
      dir="rtl"
    >
      <header className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5">
        <Link to="/" className="flex items-center gap-2">
          <div className="grid size-9 place-items-center rounded-lg bg-primary/10 text-primary">
            <Phone className="size-5" />
          </div>
          <span className="font-heading text-lg font-semibold tracking-tight">Easy Call</span>
        </Link>
        <Button asChild variant="ghost" size="sm" className="gap-1 text-muted-foreground">
          <Link to="/">
            <ArrowRight className="size-4" />
            חזרה לעמוד הבית
          </Link>
        </Button>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <Card className="w-full max-w-md shadow-xl backdrop-blur">
          <CardHeader className="items-center text-center">
            <div className="mb-2 rounded-2xl bg-primary/10 p-4">
              <Phone className="h-8 w-8 text-primary" />
            </div>
            <CardTitle className="text-2xl">התחברות / הרשמה</CardTitle>
            <CardDescription>
              התחבר עם Google. חשבון חדש מקבל אוטומטית <strong>72 שעות ניסיון חינם</strong>.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button asChild size="lg" className="w-full">
              <a href="/auth/google">
                <svg className="me-2 h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09 0-.73.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                התחבר עם Google
              </a>
            </Button>
            <p className="flex items-center justify-center gap-1.5 text-center text-xs text-muted-foreground">
              <ShieldCheck className="h-3.5 w-3.5 text-primary" />
              ההתחברות מאובטחת. חשבון חדש מתחיל בניסיון של 72 שעות.
            </p>
          </CardContent>
        </Card>
      </main>

      <footer className="py-4 text-center text-xs text-muted-foreground">
        Easy Call · מבית abaye
      </footer>
    </div>
  );
}
